import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import FieldDetail from '#client/components/TransactionDetailModal/components/FieldDetail';
import MoneyDetail from '#client/components/TransactionDetailModal/components/MoneyDetail';
import { DATE_FORMAT } from '#client/constants/date';

export default function DebitCardPaymentDetail({ amount, createdAt, updateAt }) {
  const createdAtText = createdAt ? dayjs(createdAt).format(DATE_FORMAT.MOVE_MONEY) : undefined;
  const updateAtText = updateAt ? dayjs(updateAt).format(DATE_FORMAT.MOVE_MONEY) : undefined;

  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', md: '56px' }}
      pt={{ xs: '24px', md: '32px' }}
      px={{ xs: '24px', md: '32px' }}
      rowSpacing={{ xs: '16px', md: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            Transaction details
          </Text>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="AMOUNT"
            value={amount}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="DATE INITIATED"
        value={createdAtText}
      />
      <FieldDetail
        label="DATE COMPLETED"
        value={updateAtText}
      />
      <FieldDetail
        label="TRANSACTION TYPE"
        value="Instant deposit"
      />
    </Grid>
  );
}

DebitCardPaymentDetail.propTypes = {
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  updateAt: PropTypes.string
};
